import React from 'react';
import { connect } from 'react-redux';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Segmented from "rc-segmented";

import LoadingControl from '../../../../../components/LoadingControl';
import PopupCustomized from '../../../../../components/PopupCustomized';
import ProgressOverTimeChart from '../../../../../components/v3/Graphs/QaDashboard/ProgressOverTimeChart';
import PieChart from '../../../../../components/v3/Graphs/Calibration/PieChart';
import StackedBar100Chart from '../../../../../components/v3/Graphs/QaDashboard/StackedBar100Chart';

import FilterArrow from '../../../../../icons/v3/FilterArrow';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import ContactPhoneIcon from '@material-ui/icons/ContactPhone';
import TextsmsIcon from '@material-ui/icons/Textsms';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import HelpOutline from '@material-ui/icons/HelpOutline';

import SelectTable from '../../../../../components/v3/CalibrationScreenV3/SelectTable';
import { colors, filterType } from '../../../../../constants';
import { isDefined, getOnlyUnique, cloneArray, arrayIsNotEmpty } from '../../../../../utils';

import {
    updateProps,
    loadProgressOverTimeStats,
    loadResponseBreakdown
} from '../../QaDashboardScreenActions';

import {
    SurveyType
} from '../../../../../generated';

class QaCharts extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showSelectTeamPopup: false,
            showSelectReasonsForContactPopup: false,
            showSelectChannelPopup: false,
            selectedSurveyFormTypeId: SurveyType.Agent,
            selectedTeams: undefined,
            selectedReasonForContact: undefined,
            selectedChannel: undefined,
            mouseClickX: 100,
            mouseClickY: 100
        };

        this.showSelectTeamPopup = this.showSelectTeamPopup.bind(this);
        this.hideSelectTeamPopup = this.hideSelectTeamPopup.bind(this);

        this.showSelectReasonsForContactPopup = this.showSelectReasonsForContactPopup.bind(this);
        this.hideSelectReasonsForContactPopup = this.hideSelectReasonsForContactPopup.bind(this);

        this.showSelectChannelPopup = this.showSelectChannelPopup.bind(this);
        this.hideSelectChannelPopup = this.hideSelectChannelPopup.bind(this);

        this.getSelectTeamPopup = this.getSelectTeamPopup.bind(this);
        this.getSelectReasonForContactPopup = this.getSelectReasonForContactPopup.bind(this);
        this.getSelectChannelPopup = this.getSelectChannelPopup.bind(this);

        this.getSelectedTeamsNode = this.getSelectedTeamsNode.bind(this);
        this.getSelectedReasonForContactNode = this.getSelectedReasonForContactNode.bind(this);
        this.getSelectedChannelNode = this.getSelectedChannelNode.bind(this);

        this.getResponseBreakdownNode = this.getResponseBreakdownNode.bind(this);

        this.setSelectedSurveyFormTypeId = this.setSelectedSurveyFormTypeId.bind(this);

        this.removeReasonForContact = this.removeReasonForContact.bind(this);
        this.removeChannel = this.removeChannel.bind(this);
        this.removeTeam = this.removeTeam.bind(this);

        this.showTeamComparisonHelpPopup = this.showTeamComparisonHelpPopup.bind(this);
        this.closeTeamComparisonHelpPopup = this.closeTeamComparisonHelpPopup.bind(this);
        this.showProgressOverTimeHelpPopup = this.showProgressOverTimeHelpPopup.bind(this);
        this.closeProgressOverTimeHelpPopup = this.closeProgressOverTimeHelpPopup.bind(this);
    }

    showTeamComparisonHelpPopup(e) {
        this.setState({ showTeamComparisonHelpPopup: true, mouseClickX: e.clientX, mouseClickY: e.clientY });
    }

    closeTeamComparisonHelpPopup() {
        this.setState({ showTeamComparisonHelpPopup: false });
    }

    showProgressOverTimeHelpPopup(e) {
        this.setState({ showProgressOverTimeHelpPopup: true, mouseClickX: e.clientX, mouseClickY: e.clientY });
    }

    closeProgressOverTimeHelpPopup() {
        this.setState({ showProgressOverTimeHelpPopup: false });
    }

    showSelectTeamPopup() {
        this.setState({ showSelectTeamPopup: true });
    }

    hideSelectTeamPopup(selectedTeams) {
        this.setState({ showSelectTeamPopup: false });

        if (((!selectedTeams || selectedTeams.length == 0) &&
            (!this.state.selectedTeams || this.state.selectedTeams.length == 0))) {
            return;
        }
        if (selectedTeams && this.state.selectedTeams) {
            if (JSON.stringify(selectedTeams) == JSON.stringify(this.state.selectedTeams)) {
                return;
            }
        }

        if (selectedTeams && selectedTeams.length == 0)
            this.setState({ selectedTeams: undefined });
        else {
            this.setState({ selectedTeams });
        }
    }

    showSelectReasonsForContactPopup() {
        this.setState({ showSelectReasonsForContactPopup: true });
    }

    hideSelectReasonsForContactPopup(selectedReasonForContact) {
        const
            {
                fromDate,
                toDate,
                selectedTimePeriodicity,
                onSelectRfc
            } = this.props;
        this.setState({ showSelectReasonsForContactPopup: false });

        if (((!selectedReasonForContact || selectedReasonForContact.length == 0) &&
            (!this.state.selectedReasonForContact || this.state.selectedReasonForContact.length == 0)) ||
            (selectedReasonForContact && this.state.selectedReasonForContact &&
                selectedReasonForContact.id == this.state.selectedReasonForContact.id)) {
            return;
        }

        if (!arrayIsNotEmpty(selectedReasonForContact)) {
            this.setState({ selectedReasonForContact: undefined });
            onSelectRfc();
        }
        else {
            this.setState({ selectedReasonForContact: selectedReasonForContact[0] });
            onSelectRfc(selectedReasonForContact[0]);
        }

        this.props.dispatch(updateProps({ progressOverTimeStats: undefined }));

        const selectedReasonForContactId = arrayIsNotEmpty(selectedReasonForContact)
            ? selectedReasonForContact[0].id : undefined;
        const selectedChannelId = this.state.selectedChannel ? this.state.selectedChannel.id : undefined;

        this.props.dispatch(loadProgressOverTimeStats(selectedTimePeriodicity,
            fromDate, toDate, selectedReasonForContactId, selectedChannelId));
    }

    showSelectChannelPopup() {
        this.setState({ showSelectChannelPopup: true });
    }

    hideSelectChannelPopup(selectedChannel) {
        const
            {
                fromDate,
                toDate,
                selectedTimePeriodicity,
                onSelectChannel
            } = this.props;

        this.setState({ showSelectChannelPopup: false });

        if (((!selectedChannel || selectedChannel.length == 0) &&
            (!this.state.selectedChannel || this.state.selectedChannel.length == 0)) ||
            (selectedChannel && this.state.selectedChannel &&
                selectedChannel.id == this.state.selectedChannel.id)) {
            return;
        }

        if (!arrayIsNotEmpty(selectedChannel)) {
            this.setState({ selectedChannel: undefined });
            onSelectChannel();
        }
        else {
            this.setState({ selectedChannel: selectedChannel[0] });
            onSelectChannel(selectedChannel[0]);
        }

        this.props.dispatch(updateProps({ progressOverTimeStats: undefined }));

        const selectedChannelId = arrayIsNotEmpty(selectedChannel) ? selectedChannel[0].id : undefined;
        const selectedReasonForContactId = this.state.selectedReasonForContact ? this.state.selectedReasonForContact.id : undefined;

        this.props.dispatch(loadProgressOverTimeStats(selectedTimePeriodicity,
            fromDate, toDate, selectedReasonForContactId, selectedChannelId));
    }

    setSelectedSurveyFormTypeId(value) {
        this.setState({ selectedSurveyFormTypeId: value });
        this.props.dispatch(updateProps({ responseBreakdown: undefined }));
        //this.props.dispatch(loadResponseBreakdown(value));
    }

    getSelectedTeamsNode() {
        if (!this.state.selectedTeams)
            return undefined;

        return this.getSelectedNode(filterType.team, this.state.selectedTeams, this.removeTeam);
    }

    getSelectedReasonForContactNode() {
        if (!this.state.selectedReasonForContact)
            return undefined;

        return this.getSelectedNode(filterType.reasonForContact, this.state.selectedReasonForContact, this.removeReasonForContact);
    }

    getSelectedChannelNode() {
        if (!this.state.selectedChannel)
            return undefined;

        return this.getSelectedNode(filterType.channel, this.state.selectedChannel, this.removeChannel);
    }

    removeTeam(id) {
        if (!this.state.selectedTeams || this.state.selectedTeams.length == 0)
            return;

        if (this.state.selectedTeams.length == 1) {
            this.setState({ selectedTeams: undefined });
        }
        else {
            const selectedTeamWithoutCurrent = this.state.selectedTeams.filter(t => t.id != id);
            this.setState({ selectedTeams: selectedTeamWithoutCurrent });
        }
    }

    removeReasonForContact() {
        const
            {
                fromDate,
                toDate,
                selectedTimePeriodicity,
                onSelectRfc
            } = this.props;

        this.setState({ selectedReasonForContact: undefined });
        onSelectRfc();
        const selectedChannelId = this.state.selectedChannel ? this.state.selectedChannel.id : undefined;

        this.props.dispatch(updateProps({ progressOverTimeStats: undefined }));
        this.props.dispatch(loadProgressOverTimeStats(selectedTimePeriodicity,
            fromDate, toDate, undefined, selectedChannelId));
    }

    removeChannel() {
        const
            {
                fromDate,
                toDate,
                selectedTimePeriodicity,
                onSelectChannel
            } = this.props;
        this.setState({ selectedChannel: undefined });
        onSelectChannel();
        const selectedReasonForContactId = this.state.selectedReasonForContact ? this.state.selectedReasonForContact.id : undefined;

        this.props.dispatch(updateProps({ progressOverTimeStats: undefined }));
        this.props.dispatch(loadProgressOverTimeStats(selectedTimePeriodicity,
            fromDate, toDate, selectedReasonForContactId, undefined));
    }

    getSelectedNode(filterType, selectedValue, onClick) {
        let valueAndCloseIcon;
        if (Array.isArray(selectedValue)) {
            valueAndCloseIcon = selectedValue.map((s, index) => {
                if (index < 6) {
                    return (<div className="flex-container" key={s.id}>
                        <p className="H3_14 black-text" style={{ margin: '0 8px 0 8px' }} >{s.value}</p>
                        <HighlightOffIcon onClick={() => onClick(s.id)} style={{ margin: '0 0 0 4px', color: '#98DDE1' }} />
                    </div>);
                } else if (index === 6) {
                    return (<div className="flex-container" key={s.id}>
                        <p className="H3_14 grey-text" style={{ margin: '0 8px 0 8px' }} >more...</p>
                    </div>);
                }
            }
            );
        }
        else {
            valueAndCloseIcon = (<>
                <p className="H3_14 black-text" style={{ margin: '0 8px 0 8px' }} >{selectedValue.value}</p>
                <HighlightOffIcon onClick={() => onClick(selectedValue.id)} style={{ margin: '0 0 0 4px', color: '#98DDE1' }} />
            </>);
        }
        return (
            <div className="selected-node" key={selectedValue.id}>
                <p className="H3_14 orange-text" style={{ margin: '0 8px 0 8px' }} > {filterType}</p> <FilterArrow />
                {valueAndCloseIcon}
            </div>);
    }

    getSelectReasonForContactPopup() {
        const
            {
                reasonsForContact,
            } = this.props;

        if (!reasonsForContact)
            return;

        return (<div className="modal displayBlock" >
            <div className="modal-content modal-content-selectReasonForContact">
                <SelectTable
                    title="Select a reason for contact:"
                    searchPlaceHolder="Search..."
                    options={reasonsForContact}
                    onClose={this.hideSelectReasonsForContactPopup} />
            </div>
        </div>);
    }

    getSelectChannelPopup() {
        const
            {
                channels,
            } = this.props;

        if (!channels)
            return;

        return (<div className="modal displayBlock" >
            <div className="modal-content modal-content-selectReasonForContact">
                <SelectTable
                    title="Select a channel:"
                    searchPlaceHolder="Search..."
                    options={channels}
                    onClose={this.hideSelectChannelPopup} />
            </div>
        </div>);
    }

    getSelectTeamPopup() {
        const
            {
                userTeamsStats,
            } = this.props;

        if (!isDefined(userTeamsStats))
            return;

        //To change

        return (<div className="modal displayBlock" >
            <div className="modal-content modal-content-selectTeam">
                <SelectTable
                    title="Select teams"
                    searchPlaceHolder="Search..."
                    selectMultiple={true}
                    options={userTeamsStats}
                    onClose={this.hideSelectTeamPopup} />
            </div>
        </div>);
    }

    getResponseBreakdownNode() {
        const
            {
                responseBreakdown
            } = this.props;

        if (!responseBreakdown)
            return <LoadingControl />;

        var surveyQuestionIds = responseBreakdown.surveyQuestionPotentialResponsesFrequency.map(p => p.surveyQuestionId).filter(getOnlyUnique);

        const charts = surveyQuestionIds.map(surveyQuestionId => {
            const surveyQuestion1ResponseBreakdown = responseBreakdown.surveyQuestionPotentialResponsesFrequency.filter(sf =>
                sf.surveyQuestionId === surveyQuestionId);

            const totalCount = surveyQuestion1ResponseBreakdown.map(rb => rb.count).reduce((a, b) => a + b, 0);

            const responsesToQuestion1DataPoints = surveyQuestion1ResponseBreakdown.map(r => {
                return {
                    label: r.surveyQuestionPotentialResponseName,
                    value: parseInt(100 * r.count / totalCount)
                };
            });

            let colorsSet = [colors.correctGreen, colors.neutralGrey, colors.incorrectRed];
            const graphQuestion1 = arrayIsNotEmpty(surveyQuestion1ResponseBreakdown) ? (
                <div key={surveyQuestionId} className="flex-item question-response-breakdown-chart">
                    <div className="agent-bottom-panel-title" style={{ justifyContent: 'center' }}>
                        {surveyQuestion1ResponseBreakdown[0].surveyQuestionName}
                    </div>
                    <PieChart
                        colors={colorsSet}
                        propId={surveyQuestion1ResponseBreakdown[0].surveyQuestionName}
                        dataPoints={responsesToQuestion1DataPoints} />
                </div>
            ) : <div></div>;

            return graphQuestion1;

        });

        return (<div>
            <div>
                <div className="w-full flex-grow flex justify-between items-center space-x-2"
                    style={{ marginTop: '20px' }}>
                    <div className="flex space-x-2">
                        <div className="">
                            <Segmented
                                defaultValue={this.state.selectedSurveyFormTypeId}
                                onChange={this.setSelectedSurveyFormTypeId}
                                options={[
                                    { label: "Agent", value: SurveyType.Agent },
                                    { label: "Customer", value: SurveyType.Customer },
                                ]}
                            />
                        </div>
                        {this.state.selectedSurveyFormTypeId === SurveyType.Agent &&
                            <div className="">
                                <Segmented
                                    defaultValue={this.state.selectedDataTypeId}
                                    onChange={this.setSelectedDataTypeId}
                                    options={[
                                        { label: "Jibed", value: 1 },
                                        { label: "All", value: 2 },
                                    ]}
                                />
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div className="flex-container flex-wrap" >{charts}</div>
        </div>);

    }

    render() {
        const
            {
                progressOverTimeStats,
                userTeamsStats,
                selectedQaSurveyform
            } = this.props;

        const responseBreakdownNode = this.getResponseBreakdownNode();

        const selectTeamPopup = this.state.showSelectTeamPopup ? this.getSelectTeamPopup() : undefined;
        const selectedTeamsNode = this.getSelectedTeamsNode();

        const selectReasonForContactPopup = this.state.showSelectReasonsForContactPopup ? this.getSelectReasonForContactPopup() : undefined;
        const selectedReasonForContactNode = this.getSelectedReasonForContactNode();

        const selectChannelPopup = this.state.showSelectChannelPopup ? this.getSelectChannelPopup() : undefined;
        const selectedChannelNode = this.getSelectedChannelNode();

        //const filteredTeamsInputStats = (this.state.selectedTeams && teamsInputStats)
        //    ? teamsInputStats.filter(t => this.state.selectedTeams.some(st => st.teamId === t.teamId))
        //    : teamsInputStats;

        let progressOverTimeStatsAll = []
        if (isDefined(progressOverTimeStats) && Array.isArray(progressOverTimeStats) && progressOverTimeStats.length > 0) {
            let progressOverTimeStatsCopy = cloneArray(progressOverTimeStats);

            //Filter By Team
            if (isDefined(this.state.selectedTeams) && Array.isArray(this.state.selectedTeams)
                && this.state.selectedTeams.length > 0) {
                progressOverTimeStatsCopy = progressOverTimeStatsCopy.filter(p =>
                    this.state.selectedTeams.map(st => st.id).includes(p.teamId));
            }

            var uniqueDateIndexs = progressOverTimeStatsCopy.map(p => p.dateIndex).filter(getOnlyUnique);
            var uniqueTeamIds = progressOverTimeStatsCopy.map(p => p.teamId).filter(getOnlyUnique);

            if (isDefined(this.state.selectedTeams) && Array.isArray(this.state.selectedTeams)
                && this.state.selectedTeams.length > 0) {
                progressOverTimeStatsCopy = progressOverTimeStatsCopy.filter(p =>
                    this.state.selectedTeams.map(st => st.id).includes(p.teamId));
            }

            if (progressOverTimeStatsCopy.length > 0 && isDefined(selectedQaSurveyform) && isDefined(selectedQaSurveyform.surveyFormMaxPoint)) {

                uniqueDateIndexs.map(dateIndex => {
                    const dataOfTheDay = progressOverTimeStatsCopy.filter(p => p.dateIndex === dateIndex);
                    if (arrayIsNotEmpty(dataOfTheDay)) {
                        const qaSurveyCountTotal =
                            dataOfTheDay.map(i => i.qaSurveyCount).reduce((a, b) => a + b);

                        const sumOfAverageScoreForAllSurveys = dataOfTheDay.map(i => i.surveysAverageScore * i.qaSurveyCount).reduce((a, b) => a + b);

                        const averageQaScoreTotal = (sumOfAverageScoreForAllSurveys / qaSurveyCountTotal * 100) / selectedQaSurveyform.surveyFormMaxPoint;

                        const datesAccumulatedData = {
                            dateIndex: dateIndex,
                            subToDate: dataOfTheDay[0].subToDate,
                            ticketCount: qaSurveyCountTotal,
                            averageQaScore: parseInt(averageQaScoreTotal),
                        };
                        progressOverTimeStatsAll.push(datesAccumulatedData)
                    }
                });
            }
        }

        const teamCompHelp = "QA Score Graphic displays your team's QA scores over the time range selected";
        const teamSelect = (
            <div className="v3-button" style={{ marginRight: '10px' }} onClick={this.showSelectTeamPopup}>
                <GroupAddIcon style={{ margin: '0 10px 0 0', color: '#98DDE1', transform: 'scale(-1, 1)' }} />
                Select Team
            </div>);

        const rfcSelect = (
            <div className="v3-button" style={{ display: 'inline-flex', marginRight: '10px' }} onClick={this.showSelectReasonsForContactPopup}>
                <ContactPhoneIcon style={{ margin: '0 10px 0 0', color: '#98DDE1' }} />
                Select Reason For Contact
            </div>);

        const channelSelect = (
            <div className="v3-button" onClick={this.showSelectChannelPopup}>
                <TextsmsIcon style={{ margin: '0 10px 0 0', color: '#98DDE1', transform: 'scale(-1, 1)' }} />
                Select Channel
            </div>);

        const filtersAndSelectedValues = (<div>
            <div>
                {rfcSelect}
                {teamSelect}
                {channelSelect}
            </div>
            <div style={{ display: 'inline-flex', alignItems: 'center', margin: '10px 0' }}>
                <div style={{ display: 'inline-flex', flexWrap: 'wrap' }}>
                    {selectedReasonForContactNode}
                </div>
                <div style={{ display: 'inline-flex', flexWrap: 'wrap' }}>
                    {selectedTeamsNode}
                </div>
                <div style={{ display: 'inline-flex', flexWrap: 'wrap' }}>
                    {selectedChannelNode}
                </div>
                {selectTeamPopup}
                {selectReasonForContactPopup}
                {selectChannelPopup}
            </div>
        </div>);

        return (
            <Tabs defaultIndex={2}>
                <TabList>
                    {/*
                    <Tab>
                        <div className="flex-container-center description-title">
                            <div>QA Evaluation Prediction</div>
                            <div className="flex-container-center" style={{ marginLeft: '5px' }}>
                                <HelpOutline onClick={this.showProgressOverTimeHelpPopup} />
                            </div>
                        </div>
                        {
                            this.state.showProgressOverTimeHelpPopup &&
                            <PopupCustomized
                                x={this.state.mouseClickX}
                                y={this.state.mouseClickY}
                                Message={teamCompHelp}
                                close={this.closeProgressOverTimeHelpPopup} />
                        }
                    </Tab>
                    <Tab>
                        <div className="flex-container-center description-title">
                            <div>Attributes</div>
                            <div className="flex-container-center" style={{ marginLeft: '5px' }}>
                                <HelpOutline onClick={this.showProgressOverTimeHelpPopup} />
                            </div>
                        </div>
                        {
                            this.state.showProgressOverTimeHelpPopup &&
                            <PopupCustomized
                                x={this.state.mouseClickX}
                                y={this.state.mouseClickY}
                                Message={teamCompHelp}
                                close={this.closeProgressOverTimeHelpPopup} />
                        }
                    </Tab>
                    */ }
                    <Tab>
                        <div className="flex-container-center description-title">
                            <div>Avg QA Scores</div>
                            <div className="flex-container-center" style={{ marginLeft: '5px' }}>
                                <HelpOutline onClick={this.showTeamComparisonHelpPopup} />
                            </div>
                        </div>
                        {
                            this.state.showTeamComparisonHelpPopup &&
                            <PopupCustomized
                                x={this.state.mouseClickX}
                                y={this.state.mouseClickY}
                                Message={teamCompHelp}
                                close={this.closeTeamComparisonHelpPopup} />
                        }
                    </Tab>
                </TabList>
                {/*
                <TabPanel style={{ height: '565px', position: 'relative' }}>
                    {filtersAndSelectedValues}
                    <div className="graphs">
                        {responseBreakdownNode}
                    </div>
                </TabPanel>

                <TabPanel style={{ height: '565px', position: 'relative' }}>
                    {filtersAndSelectedValues}
                    <div className="graphs" style={{ height: '399px' }}>
                        <StackedBar100Chart propId={1} />
                    </div>
                </TabPanel>
                */ }

                <TabPanel style={{ height: '565px', position: 'relative' }}>
                    {filtersAndSelectedValues}
                    <div className="graphs">
                        <ProgressOverTimeChart
                            progressOverTimeStats={progressOverTimeStatsAll}
                            propId="ProgressOverTime" />
                    </div>
                </TabPanel>

            </Tabs >);
    }
};

const select = state => ({ ...state.QaDashboardManagerScreen });
export default connect(select)(QaCharts);

